import React from 'react';
import { Table, Skeleton, Empty, Button, Typography } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';

const { Text } = Typography;

const DataTable = ({ columns, data, loading, pagination, onChange, rowKey = 'id', onRefresh, onAdd }) => {
  if (loading && (!data || data.length === 0)) {
    return (
      <div style={{ background: '#fff', borderRadius: 12, padding: 20, boxShadow: 'var(--shadow-card)' }}>
        <Skeleton active paragraph={{ rows: 5 }} />
      </div>
    );
  }

  const totalRecords = pagination?.total || data?.length || 0;

  return (
    <div style={{ background: '#fff', borderRadius: 12, overflow: 'hidden', boxShadow: 'var(--shadow-card)' }}>
      {/* Toolbar */}
      <div style={{ padding: '16px 20px', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Text style={{ fontSize: 13, color: '#64748b' }}>{totalRecords} records</Text>
        {onRefresh && (
          <Button type="text" icon={<ReloadOutlined />} onClick={onRefresh} style={{ color: '#64748b' }} />
        )}
      </div>

      {/* Table */}
      <Table
        columns={columns}
        dataSource={data}
        rowKey={rowKey}
        loading={loading}
        pagination={pagination ? {
          ...pagination,
          showSizeChanger: true,
          showTotal: (total) => `Total ${total} items`
        } : false}
        onChange={onChange}
        scroll={{ x: 'max-content' }}
        rowClassName={(record, index) => index % 2 === 0 ? 'table-row-even' : 'table-row-odd'}
        onRow={(record) => ({
          tabIndex: 0
        })}
        locale={{
          emptyText: (
            <Empty
              description="No records found"
              image={Empty.PRESENTED_IMAGE_SIMPLE}
            >
              {onAdd && <Button type="primary" onClick={onAdd}>Add New</Button>}
            </Empty>
          )
        }}
      />
    </div>
  );
};

export default DataTable;